
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LoadService } from 'src/app/core/services/load.service';
import { OfferService } from 'src/app/core/services/offer.service';
import { environment } from 'src/environments/environment';
import { SesionService } from 'src/app/core/services/sesion.service';
import { BrokerService } from 'src/app/core/services/broker.service';
import { DataLayersService } from 'src/app/core/services/data-layers.service';
import { UtilitiesService } from 'src/app/core/services/utilities.service';

declare var $: any;

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalComponent implements OnInit, OnDestroy {

	step1 = true;
	step2 = false;
	private confirmModalSub?: Subscription;

	constructor(
		public load: LoadService,
		public offerService: OfferService,
		public sesion: SesionService,
		public broker: BrokerService,
		public router: Router,
		public utilities: UtilitiesService,
		private cookieService: CookieService,
		private dataLayerService: DataLayersService,
		private cdr: ChangeDetectorRef

	) { }

	ngOnInit() {
		// Ver comentario en LoadService.confirmModalChanged: el modal de confirmacion no
		// siempre refresca solo via zone.js al reabrirse para una nueva oferta.
		this.confirmModalSub = this.load.confirmModalChanged.subscribe(() => this.cdr.detectChanges());
	}

	ngOnDestroy() {
		this.confirmModalSub?.unsubscribe();
	}

	close() {
		this.load.close("#notRequirementModal");
		this.offerService.offerRequirement = true;
	}

	steptyC(a: any) {
		if (a == 1) {
			this.step1 = false;
			this.step2 = true;
		} else {
			this.step1 = true;
			this.step2 = false;
		}
	}
	closeSession() {
		// $("#termsAndConditions").on('hidden.bs.modal', function () {
		// 	$(this).data('bs.modal', null);
		// });
		const body = {
			clientId: environment.clientId,
			idSession: this.sesion.sesionCookie,
			country: environment.country
		};
		this.broker.cerrar_sesion(body).subscribe((response: any) => {
			this.borrarData();
		},
			(error) => {
				this.borrarData();
			});
		//$(".modal-backdrop").css({"opacity": "0", "display": "none"});
	}

	borrarData() {
		window.localStorage.clear();
		this.cookieService.delete('IDSESSIONMDC', this.sesion.sesionCookie, environment.domain);
		this.sesion.sesionCookie = null;
		window.location.href = "/";
		//this.router.navigate(['/']);
	}

	saveTerms() {
		const data2 = {
			session: this.sesion.sesionCookie,
			termCondition: 12
		};

		this.broker.guardarTerminos(data2).subscribe((resultado: any) => {
			$(".modal-backdrop").css({ "opacity": "0", "display": "none" });
		}, error => {
		})
	}
	closeModalNotRequi() {
		this.load.close("#notRequirementModal");
		this.offerService.offerRequirement = true;
	}

	closeModalComments() {
		this.load.close("#comments");
	}

	closeModalNoOFertas() {
		this.load.typeNoOffers = 1;
		this.offerService.clearOfferlocalStorage();
		this.load.close("#noOfertasModal", true);
		this.router.navigate(['/ofertas']);
	}

	closeModalConfirmationV2(isCancelar: boolean = false) {
		this.offerService.errorApply = false;
		this.sesion.semiValid = false;
		this.offerService.errorPreselecta = false;
		this.load.close("#confirmationModalV2", true);

		// Forzar limpieza completa para evitar problemas de scroll y foco
		setTimeout(() => {
			this.load.forceCleanupModals();
		}, 200);

		if (isCancelar) {
			const o = this.offerService.offerSelected;
			this.dataLayerService.dl_eventoGA4_cancel_application(
				localStorage.getItem('productName'),
				localStorage.getItem('offerId'),
				localStorage.getItem('companyName'),
				DataLayersService.getOfferIsFeatured(o?.labelType ?? '0'),
				DataLayersService.getOfferLabel(o?.labelType ?? '0', o?.textLabel ?? ''),
				'Cancelar'
			);
		}
		this.offerService.clearOfferlocalStorage();
	}

}